import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-itfacility-revoke-final-approver',
  templateUrl: './itfacility-revoke-final-approver.component.html',
  styleUrls: ['./itfacility-revoke-final-approver.component.scss']
})
export class ITFacilityRevokeFinalApproverComponent implements OnInit {
public itfacilityreject_data:any={};
  constructor(public appservice:AppService, public toastr:ToastrService) { }
onApprove(){
  this.itfacilityreject_data.status='Approved';
  this.itfacilityreject_data.approvedby=this.appservice.username;
   this.appservice.getTable("api/Transaction/UpdateRevoke_forFinal?Status="+this.itfacilityreject_data.status+"&createdby="+this.appservice.username+"&id="+this.appservice.FinalRevokeEdit).subscribe((res:any)=>{
    this.toastr.success("Approved successfully!");
    //this.appservice.get_finalItFacilitygrid();
    this.appservice.goback();
  //this.appservice.ITfacilityrejectGrid();
   });
  
  
}
onDecline(){
   this.itfacilityreject_data.status='Rejected';
  this.itfacilityreject_data.approvedby=this.appservice.username;
   this.appservice.getTable("api/Transaction/UpdateRevoke_forFinal?Status="+this.itfacilityreject_data.status+"&createdby="+this.appservice.username+"&id="+this.appservice.FinalRevokeEdit).subscribe((res:any)=>{
    this.toastr.success("Rejected successfully!");
    //this.appservice.get_finalItFacilitygrid();
    this.appservice.goback();
  //this.appservice.ITfacilityrejectGrid();
   });
  
}
back(){
  this.appservice.goback();
  this.appservice.ITfacilityrejectGrid();
  
}
onformload(){
  this.appservice.getTable("api/Transaction/Pr_Fetch_DataonEditfor_Revoke?id="+this.appservice.FinalRevokeEdit).subscribe((res:any)=>{
    if(res!=""){
      
      const seperate=JSON.parse(res);
      this.itfacilityreject_data=seperate[0];
      console.log("the edit data of itfacility rejection form",this.itfacilityreject_data.IR_CheckerStatus)
    }
  });
}
  ngOnInit(): void {
    this.onformload();
  }

}
